export const groupLimit = 50;

export const queryPagingLimit = 20;
